import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { Grid, Spacer } from '@revelrygroup/components'

import { Case, FlowerProduct, ObituarySnippet } from '../../types'
import EventTrackingModel from '../models/EventTrackingModel'
import styles from './styles.module.scss'
import { routes } from '../../routes'
import Loading from '../Loading'

interface Props {
  obituary: ObituarySnippet | Case
  products: FlowerProduct[]
  gaTrackingList: 'plp' | 'flower_row'
}

const FlowerstoreProducts: React.FC<Props> = ({ gaTrackingList, obituary, products }) => {
  const handleClick = (product: FlowerProduct) =>
    EventTrackingModel.trackSelectFlower(product, gaTrackingList)

  if (!products.length) {
    return (
      <div className={styles.loadingWrapper}>
        <Loading />
      </div>
    )
  }

  return (
    <Spacer verticalTop="sm">
      <Grid.Wrapper>
        <Link href={routes.memorialTrees(obituary)}>
          <a role="link" tabIndex={0}>
            <Grid.Item>
              <Grid.ImageWrapper className={styles.imageWrapper}>
                <Image
                  alt="Memorial tree"
                  className={styles.image}
                  objectFit="cover"
                  layout="fill"
                  src="/memorial-tree--grown.jpg"
                  unoptimized
                />
              </Grid.ImageWrapper>

              <Grid.Title>Plant Memorial Trees</Grid.Title>

              <Grid.SubTitle>$29.95 - $199.95</Grid.SubTitle>
            </Grid.Item>
          </a>
        </Link>

        {products.map((product) => (
          <Link href={routes.flowerstoreProduct(obituary, product)} key={product.code}>
            <a
              role="link"
              tabIndex={0}
              onClick={() => handleClick(product)}
              onKeyDown={() => handleClick(product)}
            >
              <Grid.Item>
                <Grid.ImageWrapper className={styles.imageWrapper}>
                  <Image
                    alt={product.name}
                    className={styles.image}
                    objectFit="cover"
                    layout="fill"
                    src={product.images.large}
                    unoptimized
                  />
                </Grid.ImageWrapper>

                <Grid.Title>{product.name}</Grid.Title>

                <Grid.SubTitle>${product.price}</Grid.SubTitle>
              </Grid.Item>
            </a>
          </Link>
        ))}
      </Grid.Wrapper>
    </Spacer>
  )
}

export default FlowerstoreProducts
